export var MessageModifiers;
(function (MessageModifiers) {
    MessageModifiers["Change"] = "change";
    MessageModifiers["Accepted"] = "accepted-bet";
    MessageModifiers["Purchase"] = "purchase";
    MessageModifiers["Info"] = "info";
})(MessageModifiers || (MessageModifiers = {}));
//# sourceMappingURL=MessageModifiers.js.map